import { Menu } from "antd"
import Link from "next/link"
import {
  EyeOutlined,
  InboxOutlined
} from "@ant-design/icons"
import PropTypes from "prop-types"
import ConfidentialityDisclaimer from "../confidentiality-disclaimer"

ImplementerCoordinatorMenu.propTypes = {
  step: PropTypes.any,
  submenu: PropTypes.any
}

export default function ImplementerCoordinatorMenu({ step, submenu }) {
  return (
    <>
      <Menu
        defaultSelectedKeys={[step]}
        defaultOpenKeys={[submenu]}
        theme="dark"
        className="fico main-menu"
        mode="inline">
        <Menu.SubMenu
          key="submissions"
          icon={<InboxOutlined />}
          title="Solicitudes">
          <Menu.Item key="submissions">
            <Link href="/implementer/submissions">
              Todas las solicitudes
            </Link>
          </Menu.Item>
          <Menu.Item key="ON_LOCAL_COUNCIL">
            <Link href="/implementer/submissions/status/on_local_council">
              Consejo Local
            </Link>
          </Menu.Item>
          <Menu.Item key="ON_COUNCIL">
            <Link href="/implementer/submissions/status/on_council">
              Consejo directivo
            </Link>
          </Menu.Item>
          <Menu.Item key="ON_COMMITTEE">
            <Link href="/implementer/submissions/status/on_committee">
              Comité técnico
            </Link>
          </Menu.Item>
          <Menu.Item key="ON_AGREEMENT">
            <Link href="/implementer/submissions/status/on_agreement">
              Convenio
            </Link>
          </Menu.Item>
          <Menu.Item key="REJECTED">
            <Link href="/implementer/submissions/status/rejected">
              Rechazadas
            </Link>
          </Menu.Item>
        </Menu.SubMenu>
        <Menu.SubMenu
          key="projects"
          icon={<EyeOutlined />}
          title="Proyectos">
          <Menu.Item key="active">
            <Link href="/implementer/projects">
              Activos
            </Link>
          </Menu.Item>
          <Menu.Item key="ON_CLOSURE">
            <Link href="/implementer/projects/status/on_closure">
              Concluidos
            </Link>
          </Menu.Item>
        </Menu.SubMenu>
      </Menu>
      <ConfidentialityDisclaimer />
    </>
  )
}